<template>
  <v-dialog v-model="dialog" persistent max-width="50%">
    <v-card>
      <v-toolbar color="primary">
        <v-card-title>
          <span class="text-h5">{{ $t("strings.editor_settings") }}</span>
        </v-card-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-switch
              v-model="settings.showNodeSettings"
              hide-details
              color="secondary"
              :label="
                $t('strings.open-operator-settings', { value: valueToYesNo })
              "
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="dialog = false">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn color="secondary" variant="text" @click="dialog = false">
          {{ $t("labels.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DialogSettings",
  props: {
    showDialogSettings: Boolean,
  },
  data: () => ({ settings: { showNodeSettings: false } }),
  computed: {
    dialog: {
      get() {
        return this.showDialogSettings;
      },
      set(value) {
        this.$emit("toggleModalSettings", value, this.settings);
      },
    },
    valueToYesNo() {
      return this.settings.showNodeSettings
        ? this.$t("labels.yes")
        : this.$t("labels.no");
    },
  },
  mounted() {
    localStorage.getItem("flowSettings") &&
    localStorage.getItem("flowSettings") != "undefined"
      ? (this.settings = JSON.parse(localStorage.getItem("flowSettings")))
      : localStorage.setItem("flowSettings", JSON.stringify(this.settings));
  },
};
</script>
